<template>
  <div class="counter-design-container" :class="backgroundClass" :style="[backgroundStyle, { fontFamily: localSelectedFont }]">
    <div v-if="localLabel" class="counter-design-label" :style="colorStyle">{{ localLabel }}</div>
    <h1 class="counter-text" :style="colorStyle">{{ localCount }}</h1>
  </div>
</template>

<script>
export default {
  props: {
    selectedFont: {
      type: String,
      required: true
    },
    backgroundShape: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      required: true
    },
    textColor: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      localCount: parseInt(localStorage.getItem('count') || '0'),
      localLabel: localStorage.getItem('label') || '',
      localSelectedFont: this.selectedFont,
      localBackgroundShape: this.backgroundShape,
      localBackgroundColor: this.backgroundColor,
      localTextColor: decodeURIComponent(this.textColor),
    };
  },
  mounted() {
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeUnmount() {
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    handleStorageChange(event) {
      if (event.key === 'count') {
        this.localCount = parseInt(event.newValue || '0');
        console.log('カウントが更新されました:', this.localCount);
      } else if (event.key === 'label') {
        this.localLabel = event.newValue || '';
        console.log('ラベルが更新されました:', this.localLabel);
      }
    }
  },
  computed: {
    backgroundClass() {
      return {
        'bg-square': this.localBackgroundShape === 'square',
        'bg-rounded': this.localBackgroundShape === 'rounded',
        'bg-circle': this.localBackgroundShape === 'circle'
      }
    },
    backgroundStyle() {
      let style = {};
      switch (this.localBackgroundColor) {
        case 'gradient1':
          style.background = 'linear-gradient(to right, #ff7e5f, #feb47b)';
          break;
        case 'gradient2':
          style.background = 'linear-gradient(to right, #6a11cb, #2575fc)';
          break;
        case 'gradient3':
          style.background = 'linear-gradient(to right, #D9AFD9, #97D9E1)';
          break;
        case 'gradient4':
          style.background = 'linear-gradient(to right, #bdc3c7, #2c3e50)';
          break;
        default:
          style.background = 'transparent';
      }
      return style;
    },
    colorStyle() {
      return {
        color: this.localTextColor
      }
    }
  },
}
</script>

<style>
.bg-square {
  border-radius: 0;
}

.bg-rounded {
  border-radius: 15px;
}

.bg-circle {
  border-radius: 50%;
}

.counter-design-container {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  width: 200px;
  margin: 0 auto;
}

.counter-design-label {
  position: absolute;
  top: 13px;
  left: -10px;
  transform: rotate(-7deg);
  font-size: 1rem;
  color: #fff!important;
  font-weight: bold;
  z-index: 1;
  letter-spacing: 2px;
  background: #ffa4b0;
  padding: 8px 15px;
  border-radius: 5px;
}

.counter-design-label:before {
  position: absolute;
  content: '';
  top: 97%;
  left: 5px;
  border: none;
  border-bottom: solid 15px transparent;
  border-right: solid 20px #f87385;
}

.counter-text {
  font-size: 5rem;
  position: relative;
  z-index: 0;
}
</style>